import * as $ from "jquery";
const empty = require('is-empty');

export const CheckNipAndCompany = (() => {
	$.validator.addMethod("checkNipAndCompany", function(value, element, param)  {
		let companyVal = $(param).val();
		return !(!empty(value) && empty(companyVal))
	},
	$.validator.format("Musisz wyszukać lub uzupełnić dane do faktury"));
})();import * as $ from "jquery";
const empty = require('is-empty');

export const CheckNipAndCompany = (() => {
	$.validator.addMethod("checkNipAndCompany", function(value, element, param)  {
		let companyVal = $(param).val();
		return !(!empty(value) && empty(companyVal))
	},
	$.validator.format("Musisz wyszukać lub uzupełnić dane do faktury"));
})();